import { render, staticRenderFns } from "./AssetClassification.vue?vue&type=template&id=1191dff6&scoped=true&"
import script from "./AssetClassification.vue?vue&type=script&lang=js&"
export * from "./AssetClassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1191dff6",
  null
  
)

export default component.exports